import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import QuestionCreate from '../components/QuestionCreate';
import api from '../api';
import slugMapSelector from '../selectors/slugMapSelector';
import { getAuthenticatedAccountId } from '../selectors/auth';
import { getSelectedProfile } from '../selectors/profiles';

const QuestionCreateContainer = (props) => {
  const { onQuestionAdded } = props;
  
  const dispatch = useDispatch();
  const location = useLocation();

  // Grab our standard Redux data
  const { accountId, profile, slugMaps } = useSelector((state) => ({
    accountId: getAuthenticatedAccountId(state),
    profile: getSelectedProfile(state),
    slugMaps: slugMapSelector(state),
  }), shallowEqual);

  // Replaces componentDidMount
  useEffect(() => {
    dispatch(api.actions.questionsCreate.reset({}));
  }, [dispatch]);

  const handleSubmit = useCallback((values) => {
    dispatch(api.actions.questionsCreate.reset({}));
    
    const { includeLocation } = values;
    const cleanedUpValues = _.omit(values, ['includeLocation']);
    cleanedUpValues.date = new Date();
    
    if (includeLocation) {
      cleanedUpValues.pathname = location.pathname;
    }

    dispatch(api.actions.questionsCreate(
      { accountId, profileId: profile.id },
      {
        body: JSON.stringify({
          id: uuidv4(),
          ...cleanedUpValues
        })
      }
    ));
    
    if (onQuestionAdded) {
      onQuestionAdded();
    }
  }, [dispatch, location.pathname, accountId, profile?.id, onQuestionAdded]);

  return (
    <QuestionCreate
      {...props}
      onSubmit={handleSubmit}
      location={location}
      slugMaps={slugMaps}
    />
  );
};

QuestionCreateContainer.propTypes = {
  onQuestionAdded: PropTypes.func.isRequired,
};

export default QuestionCreateContainer;
